// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~web/react/components/common/styles/colors.css\"","color-black":"#000000","colorBlack":"#000000","secondaryMenuHeader":"_1Kpb8 _1R_Wx","menuItemBigChevron":"_231oY"};